import type { TileOf } from '@casa/model';
import type { IconDefinition } from '../../elements/icon.ts';
import { iconElement, type LayoutElement } from '../../elements/layout_elements.ts';

/**
 * The legacy `action` tile (`ActionTile.cs`, `ActionTileView.xaml`): a button. Its icon in white,
 * no state; a tap sends the tile's command, with its argument, to its source's driver, with the
 * tap feedback.
 */

export type ActionTile = TileOf<'action'>;

/** `White`, as the legacy view had it. */
export const ACTION_ICON_COLOR = '#ffffff';

export function actionTileElements(icon: IconDefinition | undefined, color = ACTION_ICON_COLOR) : LayoutElement[] {
    return [iconElement({ center: 'parent.center', w: 'parent.width*0.8', h: 'parent.height*0.8' }, icon, color, { fill: true })];
}
